// Simple localStorage JSON helpers to persist UI state across navigations
export const loadState = (key, defaultValue) => {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw == null) return defaultValue;
    return JSON.parse(raw);
  } catch (e) {
    return defaultValue;
  }
};

export const saveState = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // ignore write failures
  }
};
